import React from 'react';
import './Notes.css'; // Import CSS for styling

function Notes() {
  return (
    <div className="notes-page">
      <p>
        um, so this page will be up for as long as vidya's able to maintain it.
      </p>
      <p>
        In the case that she lets it die, she says sorry in advance, but also that she'll send an archive of all messages or something. TBD!
      </p>
      <p>
        If you have ideas on how to let this site die gracefully please let her know <a href='https://x.com/dvj918'>here</a>.
      </p>
    </div>
  );
}

export default Notes;
